import React, { MouseEvent } from 'react';
import styled from 'styled-components';
import { Container } from './Container';
import { Button } from './buttons/Button';
import { Colors } from '../constants/colors';
import { Device } from '../constants/device';
import { useTranslation } from 'react-i18next';

type DemoCtaProps = {
  compact?: boolean;
  inverse?: boolean;
  /** The home page shows the CTA twice, so each one needs its own heading. */
  titleKey?: string;
};

export const DemoCta = ({ compact, inverse, titleKey = 'cta.title' }: DemoCtaProps) => {
  const { t } = useTranslation();

  const scrollToContact = (event: MouseEvent) => {
    event.preventDefault();
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <StyledCtaSection className={inverse ? 'inverse' : ''}>
      <Container>
        <CtaBox compact={compact}>
          <CtaHeading>{t(titleKey)}</CtaHeading>
          {!compact && <CtaText>{t('cta.text')}</CtaText>}
          <Button as="a" href="#contact" onClick={scrollToContact} inverse maxWidth={'300px'}>
            {t('cta.button')}
          </Button>
        </CtaBox>
      </Container>
    </StyledCtaSection>
  );
};

const StyledCtaSection = styled.section`
  padding: 0 0 100px;

  &.inverse {
    background: ${Colors.white};
  }

  ${Device.tablet} {
    padding: 0 0 60px;
  }
`;

const CtaBox = styled.div<{ compact?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${(props) => (props.compact ? '15px' : '20px')};
  padding: ${(props) => (props.compact ? '30px 40px' : '40px')};
  border-radius: 20px;
  background: ${Colors.primary};
  color: ${Colors.white};
  align-self: center;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;

  a {
    width: auto;
  }
`;

const CtaHeading = styled.h2`
  margin: 0;
`;

const CtaText = styled.p`
  margin: 0;
`;
